<template>
  <div class="styj">

    <Head v-bind:headTxt="headTxt"></Head>

    <YangBen v-bind:YangBenBox="YangBenBox"></YangBen>

    <ShiJi v-bind:shiJiBox="shiJiBox"></ShiJi>

    <RightBox v-bind:rightBox="rightBox"></RightBox>

    <div class="map_box">
      <Map v-bind:mapBut="mapBut"></Map>
    </div>

    <div class="l_box">
      <div class="bgc l_box_1">
        <div class="box_1_zs">
          <span class="txtc">{{(xfwmList.c_Story_red) + (xfwmList.c_Story_unity) + (xfwmList.c_Story_story)}}</span>
          <p>总数</p>
        </div>
        <div class="box_1_nr">
          <div class="nr_title title">民间故事</div>
          <div class="nr_txt">
            红色故事：{{xfwmList.c_Story_red}}个&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            团结故事：{{xfwmList.c_Story_unity}}个&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            当地传说：{{xfwmList.c_Story_story}}个
          </div>
          <div class="nr_but"><span @click="goTo('/mjgs')">more>>></span></div>
        </div>
      </div>
      <div class="bgc l_box_1">
        <div class="box_1_zs">
          <span class="txtc">{{(xfwmList.c_Tradition_sports) + (xfwmList.c_Tradition_celebration) + (xfwmList.c_Tradition_festival)}}</span>
          <p>总数</p>
        </div>
        <div class="box_1_nr">
          <div class="nr_title title">民俗文化活动</div>
          <div class="nr_txt">
            传统体育：{{xfwmList.c_Tradition_sports}}个&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            传统庆典：{{xfwmList.c_Tradition_celebration}}个&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            传统节日：{{xfwmList.c_Tradition_festival}}个
          </div>
          <div class="nr_but"><span @click="goTo('/mshd')">more>>></span></div>
        </div>
      </div>
      <div class="l_box_2">
        <div class="bgc box_2_1">
          <div class="title box_2_1_title">
            特色风味
            <div><span>总数：{{xfwmList.c_Feature_relish}}</span></div>
          </div>
          <div class="box_2_1_img">
            <div v-show="tesechiImgList.length > 0">
              <el-carousel height="100%"
                           indicator-position="none">
                <el-carousel-item v-for="(item,index) in tesechiImgList"
                                  :key="index">
                  <el-image style="width:100%; height:100%"
                            :src="item"
                            fit="cover"></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="tesechiImgList.length == 0">
              <span class="noTxt"
                    style="line-height:20vh;margin-left:30%">暂无调研图片</span>
            </div>
          </div>
          <div class="box_2_1_but"><span @click="goTo('/tsfw')">more>>></span></div>
        </div>
        <div class="bgc box_2_1"
             style="margin-left: 1vh;">
          <div class="title box_2_1_title">
            非遗
            <div><span>总数：{{xfwmList.c_No_heritage}}</span></div>
          </div>
          <div class="box_2_1_img">
            <div v-show="feiyiImgList.length > 0">
              <el-carousel height="100%"
                           indicator-position="none">
                <el-carousel-item v-for="(item,index) in feiyiImgList"
                                  :key="index">
                  <el-image style="width:100%; height:100%"
                            :src="item"
                            fit="cover"></el-image>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-show="feiyiImgList.length == 0">
              <span class="noTxt"
                    style="line-height:20vh;margin-left:30%">暂无调研图片</span>
            </div>
          </div>
          <div class="box_2_1_but"><span @click="goTo('/mjgs')">more>>></span></div>
        </div>
      </div>
      <div class="l_box_3">
        <div class="bgc box_3_1">
          <div v-show="jianzhuImgList1.length > 0">
            <el-carousel height="100%"
                         indicator-position="none">
              <el-carousel-item v-for="(item,index) in jianzhuImgList1"
                                :key="index">
                <el-image style="width:100%; height:100%"
                          :src="item"
                          fit="cover"></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-show="jianzhuImgList1.length == 0">
            <span class="noTxt"
                  style="line-height:15vh;margin-left:23%">暂无调研图片</span>
          </div>
        </div>
        <div class="bgc box_3_1"
             style="margin-left: 1vh;">
          <div v-show="jianzhuImgList2.length > 0">
            <el-carousel height="100%"
                         indicator-position="none">
              <el-carousel-item v-for="(item,index) in jianzhuImgList2"
                                :key="index">
                <el-image style="width:100%; height:100%"
                          :src="item"
                          fit="cover"></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-show="jianzhuImgList2.length == 0">
            <span class="noTxt"
                  style="line-height:15vh;margin-left:23%">暂无调研图片</span>
          </div>
        </div>
        <div class="bgc box_3_1"
             style="margin-left: 1vh;">
          <div v-show="teseImgList.length > 0">
            <el-carousel height="100%"
                         indicator-position="none">
              <el-carousel-item v-for="(item,index) in teseImgList"
                                :key="index">
                <el-image style="width:100%; height:100%"
                          :src="item"
                          fit="cover"></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div v-show="teseImgList.length == 0">
            <span class="noTxt"
                  style="line-height:15vh;margin-left:23%">暂无调研图片</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import YangBen from '@/components/YangBen.vue'
import RightBox from '@/components/RightBox.vue'
import ShiJi from '@/components/ShiJi.vue'
import Map from '@/components/Map.vue'
import bus from '../utils/bus.js'


export default {
  components: {
    Head,
    YangBen,
    RightBox,
    ShiJi,
    Map
  },
  data () {
    return {
      city_id: 0,
      xfwmList: {},

      YangBenBox: {
        xian: '123',
        xiang: '12',
        cun: '1'
      },
      shiJiBox: {
        shiJiTitle: '乡风文明大事记',
        diDian: '湖南省',
        shiJiList: [
          '勾蓝瑶寨农村环境整治整体推进综合治理项目，自2018年6月开工建设以来，共投资60余万元，对全村进行集中整治。建设了农村饮用水项目、生活污水治理项目、生活垃圾收集系统、农村改厕改水和农村“五清五化”治理等。',
          '2022年8月，青年水库，水域面积750多亩，总库容600余万立方米，主要用于农业灌溉、城市生态补水、防洪排涝、景观用水等，提升青年水库水质，加强周边生态环境保护尤为重要。',
        ]
      },
      rightBox: {
        boxTitle: '湖南民族地区乡村乡风文明简介',
        boxText: '湖南地形以山地丘陵为主，大陆性亚热带季风湿润气候。党的十八大以来,湖南深入践行习近平生态文明思想,牢记“守护好一江碧水”的殷殷嘱托,以前所未有的力度推进生态文明建设,全省生态环境发生了历史性、转折性、全局性变化。',
        images: [],
      },
      headTxt: '乡风文明数据仓',
      mapBut: '湖南旅游地图>>>',

      teseImgList: [],
      tesechiImgList: [],
      feiyiImgList: [],
      jianzhuImgList1: [],
      jianzhuImgList2: [],
    }
  },
  mounted () {
    this.getDate()

    bus.$on('mapBus', (date) => {
      console.log(date, 'mapBushhhhhh')
      this.city_id = date.city_id
      this.getDate(date)
    })
  },
  methods: {
    getDate (date) {
      let newDate = "";
      if (date) {
        newDate = date.region;
      } else {
        newDate = "永州市";
      }

      console.log(this.city_id);
      var date = JSON.parse(localStorage.getItem("date"));
      date.forEach((item, index) => {
        if (item.region == newDate) {
          this.xfwmList = item;
        }
      });

      this.rightBox.images = []
      const introList = this.xfwmList.culture_intro.split('#')
      this.rightBox.boxText = introList[0]
      for (let i = 1; i < introList.length; i++)
      {
        this.rightBox.images.push(introList[i])
      }
      console.log(this.rightBox, '数据处理后');

      // 处理特色风味图片
      var food_imgList = []
      var snack_imgList = []
      var drinks_imgList = []
      food_imgList = this.xfwmList.clist.map((item) => {
        return item.food_img
      })
      snack_imgList = this.xfwmList.clist.map((item) => {
        return item.snack_img
      })
      drinks_imgList = this.xfwmList.clist.map((item) => {
        return item.drinks_img
      })
      this.tesechiImgList = food_imgList.concat(snack_imgList)
      this.tesechiImgList = this.tesechiImgList.concat(drinks_imgList)
      for (var i = this.tesechiImgList.length - 1; i >= 0; i--)
      {
        if (this.tesechiImgList[i] == "" || this.tesechiImgList[i] == null)
        {
          this.tesechiImgList.splice(i, 1);
        }
      }
      if (this.tesechiImgList.length > 0)
      {
        this.tesechiImgList = this.tesechiImgList.join('、')
        this.tesechiImgList = this.tesechiImgList.split('、')
      }
      console.log(this.tesechiImgList, '特色风味图片');

      // 处理特色服饰图片
      var clothing_imgList = []
      var ornament_imgList = []
      clothing_imgList = this.xfwmList.clist.map((item) => {
        return item.clothing_img
      })
      ornament_imgList = this.xfwmList.clist.map((item) => {
        return item.ornament_img
      })
      this.teseImgList = clothing_imgList.concat(ornament_imgList)
      for (var i = this.teseImgList.length - 1; i >= 0; i--)
      {
        if (this.teseImgList[i] == "" || this.teseImgList[i] == null)
        {
          this.teseImgList.splice(i, 1);
        }
      }
      if (this.teseImgList.length > 0)
      {
        this.teseImgList = this.teseImgList.join('、')
        this.teseImgList = this.teseImgList.split('、')
      }
      console.log(this.teseImgList, '特色服饰图片');

      // 处理非遗图片
      this.feiyiImgList = this.xfwmList.clist.map((item) => {
        return item.inheritor_img
      })
      for (var i = this.feiyiImgList.length - 1; i >= 0; i--)
      {
        if (this.feiyiImgList[i] == "" || this.feiyiImgList[i] == null)
        {
          this.feiyiImgList.splice(i, 1);
        }
      }
      if (this.feiyiImgList.length > 0)
      {
        this.feiyiImgList = this.feiyiImgList.join('、')
        this.feiyiImgList = this.feiyiImgList.split('、')
      }
      console.log(this.feiyiImgList, '非遗图片');

      // 处理特色建筑1图片
      var temple_imgList = this.xfwmList.clist.map((item) => {
        return item.temple_img
      })
      var play_imgList = this.xfwmList.clist.map((item) => {
        return item.play_img
      })
      var religion_imgList = this.xfwmList.clist.map((item) => {
        return item.religion_img
      })
      var facade_imgList = this.xfwmList.clist.map((item) => {
        return item.facade_img
      })
      this.jianzhuImgList1 = temple_imgList.concat(play_imgList)
      this.jianzhuImgList1 = this.jianzhuImgList1.concat(religion_imgList)
      this.jianzhuImgList1 = this.jianzhuImgList1.concat(facade_imgList)
      for (var i = this.jianzhuImgList1.length - 1; i >= 0; i--)
      {
        if (this.jianzhuImgList1[i] == "" || this.jianzhuImgList1[i] == null)
        {
          this.jianzhuImgList1.splice(i, 1);
        }
      }
      if (this.jianzhuImgList1.length > 0)
      {
        this.jianzhuImgList1 = this.jianzhuImgList1.join('、')
        this.jianzhuImgList1 = this.jianzhuImgList1.split('、')
      }
      console.log(this.jianzhuImgList1, '特色建筑1图片');

      // 处理特色建筑2图片
      var courtyard_imgList = this.xfwmList.clist.map((item) => {
        return item.courtyard_img
      })
      var living_imgList = this.xfwmList.clist.map((item) => {
        return item.living_img
      })
      var bedroom_imgList = this.xfwmList.clist.map((item) => {
        return item.bedroom_img
      })
      var kitchen_imgList = this.xfwmList.clist.map((item) => {
        return item.kitchen_img
      })
      this.jianzhuImgList2 = living_imgList.concat(courtyard_imgList)
      this.jianzhuImgList2 = this.jianzhuImgList2.concat(bedroom_imgList)
      this.jianzhuImgList2 = this.jianzhuImgList2.concat(kitchen_imgList)
      for (var i = this.jianzhuImgList2.length - 1; i >= 0; i--)
      {
        if (this.jianzhuImgList2[i] == "" || this.jianzhuImgList2[i] == null)
        {
          this.jianzhuImgList2.splice(i, 1);
        }
      }
      if (this.jianzhuImgList2.length > 0)
      {
        this.jianzhuImgList2 = this.jianzhuImgList2.join('、')
        this.jianzhuImgList2 = this.jianzhuImgList2.split('、')
      }
      console.log(this.jianzhuImgList2, '特色建筑2图片');


      // 处理大事记数据
      this.shiJiBox.shiJiList = this.xfwmList.clist.map((item) => {
        return item.event_date + '  |  ' + item.event_influence + '  |  ' + item.event_name
      })
      console.log(this.shiJiBox.shiJiList, 'hhhhhhhh');
      for (var i = this.shiJiBox.shiJiList.length - 1; i >= 0; i--)
      {
        if (this.shiJiBox.shiJiList[i] == "  |    |  " || this.shiJiBox.shiJiList[i] == "null  |  null  |  null" || this.shiJiBox.shiJiList[i] == "无  |  无  |  无")
        {
          this.shiJiBox.shiJiList.splice(i, 1);
        }
      }
      console.log(this.shiJiBox.shiJiList);
    },

    // 跳转
    goTo (toPath) {
      this.$router.push(toPath)
    }
  }
}
</script>

<style lang="less" scoped>
.map_box {
  position: absolute;
  top: 7vh;
  left: 35%;
  width: 39%;
  height: 87vh;
}

.l_box {
  position: absolute;
  top: 16vh;
  left: 0;
  width: 34%;
  height: 58vh;
  margin: 1vh;

  .l_box_1 {
    display: flex;
    margin-bottom: 1vh;
    height: 12vh;

    .box_1_zs {
      margin: auto;
      flex: 1;
      text-align: center;
      margin-left: 1vh;
      padding-bottom: 1%;

      span {
        font-size: calc(100vw * 60 / 1920);
        font-weight: 900;
        // color: #0099cc;
      }
    }

    .box_1_nr {
      flex: 5;

      .nr_title {
        padding: 1vh 0;
        margin: 0 3vh;
        text-align: center;
        // font-size: calc(100vw * 16 / 1920);
        // font-weight: 800;
        border-bottom: 2px solid #666;
      }

      .nr_txt {
        padding: 1.5vh 0;
        text-align: center;
      }

      .nr_but {
        margin-right: 1vh;
        text-align: right;
      }
      span:hover {
        cursor: pointer;
        color: rgb(30, 116, 255);
      }
    }
  }

  .l_box_2 {
    display: flex;
    margin-bottom: 1vh;
    height: 23vh;

    .box_2_1 {
      flex: 1;
      .box_2_1_title {
        display: flex;
        div {
          flex: 1;
          text-align: right;
          margin-right: 1vh;
        }
      }

      .box_2_1_img {
        height: 18vh;
        div {
          width: 100%;
          height: 100%;
        }
      }

      .box_2_1_but {
        padding: 0 0.5vh 1vh 0;
        margin: auto;
        text-align: right;
        span:hover {
          cursor: pointer;
          color: rgb(30, 116, 255);
        }
      }
    }
  }

  .l_box_3 {
    display: flex;
    height: 15vh;

    .box_3_1 {
      flex: 1;

      div {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>